module.exports = __webpack_public_path__ + "media/images/fb-245e33c81b159392c8a981869d643267.svg";